import { createRoute } from "@tanstack/react-router";

import { lazyWithRetry } from "@shared/lib/lazy";

import { renderProtectedRoute } from "@app/router/routeElements";
import { rootRoute } from "@app/router/rootRoute";

const themesIndex = lazyWithRetry(() => import("./routes/index"));
const themesUpload = lazyWithRetry(() => import("./routes/upload"));
const themeSlots = lazyWithRetry(() => import("./routes/[id]/slots"));
const themeVariables = lazyWithRetry(() => import("./routes/[id]/variables"));
const themeSettings = lazyWithRetry(() => import("./routes/[id]/settings"));

const themesIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/themes",
  component: () =>
    renderProtectedRoute(themesIndex, { requirePerms: ["themes:read"] }),
});

const themesUploadRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/themes/upload",
  component: () =>
    renderProtectedRoute(themesUpload, { requirePerms: ["themes:write"] }),
});

const themeSlotsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/themes/$id/slots",
  component: () =>
    renderProtectedRoute(themeSlots, { requirePerms: ["themes:read"] }),
});

const themeVariablesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/themes/$id/variables",
  component: () =>
    renderProtectedRoute(themeVariables, { requirePerms: ["themes:read"] }),
});

const themeSettingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/themes/$id/settings",
  component: () =>
    renderProtectedRoute(themeSettings, { requirePerms: ["themes:read"] }),
});

export const themesRouteTree = [
  themesIndexRoute,
  themesUploadRoute,
  themeSlotsRoute,
  themeVariablesRoute,
  themeSettingsRoute,
];
